/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const TeamActionTypes =
  {"CREATE_PAGE_CONTENTS":"createPageContents","CREATE_PROJECT_CUSTOM_EMAIL_SET":"createProjectCustomEmailSet","SEARCH_PARTICIPANTS":"searchParticipants","VIEW_BILLING_INFO":"viewBillingInfo","VIEW_PAGE_CONTENTS":"viewPageContents","VIEW_PROJECT_CUSTOM_EMAIL_SETS":"viewProjectCustomEmailSets"} as const;
